import type { Interval } from 'date-fns';
import {
  addBusinessDays,
  addDays,
  addHours,
  addMinutes,
  addMonths,
  addQuarters,
  addWeeks,
  areIntervalsOverlapping,
  differenceInDays,
  differenceInMinutes,
  endOfDay,
  endOfMonth,
  endOfQuarter,
  endOfWeek,
  endOfYear,
  format,
  getDate,
  getHours,
  getMinutes,
  intervalToDuration,
  isFuture,
  isPast,
  isSameDay,
  isToday,
  isTomorrow,
  isWithinInterval,
  isYesterday,
  nextFriday,
  nextSaturday,
  nextSunday,
  previousFriday,
  previousSaturday,
  previousSunday,
  roundToNearestMinutes,
  setDate,
  startOfDay,
  startOfHour,
  startOfMonth,
  startOfQuarter,
  startOfWeek,
  startOfYear,
} from 'date-fns';

const dateVendor: {
  addBusinessDays: (date: Date, days: number) => Date;
  addDays: (date: Date, days: number) => Date;
  addHours: (date: Date, hours: number) => Date;
  addMinutes: (date: Date, minutes: number) => Date;
  addMonths: (date: Date, months: number) => Date;
  addQuarters: (date: Date, quarters: number) => Date;
  addWeeks: (date: Date, weeks: number) => Date;
  differenceInDays: (
    dateLeft: Date | number,
    dateRight: Date | number
  ) => number;
  differenceInMinutes: (
    dateLeft: Date | number,
    dateRight: Date | number
  ) => number;
  endOfDay: (date: Date) => Date;
  endOfMonth: (date: Date) => Date;
  endOfQuarter: (date: Date) => Date;
  endOfWeek: (date: Date) => Date;
  endOfYear: (date: Date) => Date;
  format: (date: Date, format: string) => string;
  getDate: (date: Date) => number;
  getHours: (date: Date) => number;
  getMinutes: (date: Date) => number;
  intervalToDuration: (dates: Interval) => Duration;
  isFuture: (date: Date) => boolean;
  isPast: (date: Date) => boolean;
  isSameDay: (dateLeft: Date, dateRight: Date) => boolean;
  isToday: (date: Date) => boolean;
  isTomorrow: (date: Date) => boolean;
  isWithinInterval: (date: Date, interval: Interval) => boolean;
  isYesterday: (date: Date) => boolean;
  nextFriday: (date: Date) => Date;
  nextSaturday: (date: Date) => Date;
  nextSunday: (date: Date) => Date;
  overlaps: (left: Interval, right: Interval) => boolean;
  previousFriday: (date: Date) => Date;
  previousSaturday: (date: Date) => Date;
  previousSunday: (date: Date) => Date;
  roundToNearestMinutes: (
    date: Date,
    options?: { nearestTo?: number; roundingMethod?: 'ceil' | 'floor' | 'round' }
  ) => Date;
  setDate: (date: Date, dayOfMonth: number) => Date;
  startOfDay: (date: Date) => Date;
  startOfHour: (date: Date) => Date;
  startOfMonth: (date: Date) => Date;
  startOfQuarter: (date: Date) => Date;
  startOfWeek: (date: Date) => Date;
  startOfYear: (date: Date) => Date;
} = {
  addBusinessDays,
  addDays,
  addHours,
  addMinutes,
  addMonths,
  addQuarters,
  addWeeks,
  differenceInDays,
  differenceInMinutes,
  endOfDay,
  endOfMonth,
  endOfQuarter,
  endOfWeek,
  endOfYear,
  format,
  getDate,
  getHours,
  getMinutes,
  intervalToDuration,
  isFuture,
  isPast,
  isSameDay,
  isToday,
  isTomorrow,
  isWithinInterval,
  isYesterday,
  nextFriday,
  nextSaturday,
  nextSunday,
  overlaps: areIntervalsOverlapping,
  previousFriday,
  previousSaturday,
  previousSunday,
  roundToNearestMinutes,
  setDate,
  startOfDay,
  startOfHour,
  startOfMonth,
  startOfQuarter,
  startOfWeek,
  startOfYear,
};

export default dateVendor;
